import type { CSSProperties } from "react";

interface EquationCardProps {
  /** The sum on the card, for example "7 × 8 = 56". The sign is the multiplication
   *  sign and never the letter x: this is a maths product. */
  children: string;
  /** Resting tilt in degrees. */
  tilt?: number;
  /** Offsets the float so a group of cards never moves in lockstep. */
  delay?: number;
  tone?: "paper" | "sage" | "marigold";
  className?: string;
}

/** A small card of handwriting that drifts behind the hero. Decorative only. */
export function EquationCard({ children, tilt = -6, delay = 0, tone = "paper", className }: EquationCardProps) {
  const fills: Record<string, string> = {
    paper: "var(--white)",
    sage: "var(--sage-tint)",
    marigold: "var(--marigold)",
  };
  return (
    <span
      aria-hidden="true"
      className={["eqcard", "anim-float", className].filter(Boolean).join(" ")}
      style={
        {
          "--tilt": `${tilt}deg`,
          "--delay": `${delay}ms`,
          "--float-dur": `${6 + (delay % 5) * 0.4}s`,
          background: fills[tone],
        } as CSSProperties
      }
    >
      {children}
    </span>
  );
}
